export default {
  
  props: {
    featureData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      swiper: {},
      imageList: [],
    }
  },
  watch: {
    featureData: function(val) {
      if (val.length == 0) return

      this.initImageList()
    }
  },
  methods: {
    // 设置图片为加载状态
    initImageList() {
      const imageList = []
      for (let i = 0; i < this.featureData.length; i++) {
        imageList.push({
          imageLoading: true,
          url: this.featureData[i]
        })
      }

      this.imageList = imageList

      this.initSwiper()
    },
    // 图片加载完成后取消加载状态
    handleLoad(img) {
      this.$set(img, 'imageLoading', false)
    },
  }
}